(function ($, Drupal) {

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };

  }

  Drupal.behaviors.paperpads = {
    attach: function (context, settings) {
      const { theme_path:themePath } = settings;
      const assetsPath = `/${themePath}/progressive_sub/assets`;
      const imagesPath = `${assetsPath}/images`;

        jQuery('.lazy').Lazy({
          afterLoad: function(e) {
            $('.lazy-loader').hide();
            setTimeout(() => {
              $('.slider-text').fadeIn();
            }, 6000);
          },
          onError: el => {
            console.log('error', el);
            $('.lazy').hide();
          },
          onFinishedAll: () => {
            console.log('finished all');
          }
        });
      // page slider
    //   const $pageSliderWrapper = $('#page-slider-wrapper');
    //   console.log($pageSliderWrapper);
    //   if($pageSliderWrapper.size() > 0) {
    //     console.log('found page slider wrapper');
    //     const $inner = $pageSliderWrapper.find('#page-slider');
    //     const img = $(`<img src="${imagesPath}/home_animation.gif" class="lazy" />`);
    //     $inner.append(img);
    //     $('.lazy').lazy()
    }
  };
})
(jQuery, Drupal);
